import {
    ICreateParcelLocation,
    IDeleteParcelLocation,
    IParcelLocation,
    IUpdateParcelLocation
} from "../models/parcel/IParcelLocation";
import { apiSlice } from "./apiSlice";

const PATH = "/parcel";

export const parcelApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getParcelLocations: builder.query<IParcelLocation[], string>({
            query: (parcelId) => ({
                url: `${PATH}/${parcelId}/parcellocation`
            })
        }),
        createParcelLocation: builder.mutation<
            IParcelLocation,
            ICreateParcelLocation
        >({
            query: ({ parcelId, parcelLocation }) => ({
                url: `${PATH}/${parcelId}/parcellocation`,
                method: "POST",
                body: parcelLocation
            })
        }),
        updateParcelLocation: builder.mutation<
            IParcelLocation,
            IUpdateParcelLocation
        >({
            query: ({ parcelId, parcelLocation, parcelLocationId }) => ({
                url: `${PATH}/${parcelId}/parcellocation/${parcelLocationId}`,
                method: "PUT",
                body: parcelLocation
            })
        }),
        deleteParcelLocation: builder.mutation<void, IDeleteParcelLocation>({
            query: ({ parcelId, parcelLocationId }) => ({
                url: `${PATH}/${parcelId}/parcellocation/${parcelLocationId}`,
                method: "DELETE"
            })
        })
    })
});

export const {
    useGetParcelLocationsQuery,
    useCreateParcelLocationMutation,
    useDeleteParcelLocationMutation,
    useUpdateParcelLocationMutation
} = parcelApiSlice;
